export default "__VITE_ASSET__C9gpN5bd__"